import React from "react";
import { ReactSVG } from "react-svg";
import { PreviewBrowser } from "@/components/PreviewBrowser";
import { QRType } from "@/types/qr";

import "./PhoneLayout.scss";

type PhoneLayoutProps = {
  children: React.ReactNode;
  page: QRType;
  backgroundColor?: string;
  dataQA?: string;
  isInitPreview?: boolean;
  hasIncludeBrowser?: boolean;
};

export const PhoneLayout = ({
  children,
  page,
  backgroundColor,
  dataQA,
  isInitPreview,
  hasIncludeBrowser,
}: PhoneLayoutProps) => {
  return (
    <>
      <div
        className={`phone-layout phone-layout--${page}`}
        style={{
          backgroundColor: backgroundColor,
        }}
        data-qa={dataQA}
      >
        {hasIncludeBrowser && <PreviewBrowser type={page} />}
        <div
          className={`phone-layout__content ${isInitPreview ? `${page} phone-layout__content--init-preview` : ""} ${hasIncludeBrowser ? "phone-layout__content--with-browser" : ""}`}
        >
          {children}
        </div>
      </div>
      <ReactSVG
        /* TODO: Replace "phone-empty-legacy" with "phone-empty" in upcoming changes to Previews
        Both svg are located in the /assets/images/previews folder 
        src="/images/previews/phone-empty.svg" */

        src="/images/previews/phone-empty-legacy.svg"
        className="phone-layout__frame"
      />
    </>
  );
};
